/* unplugin-vue-components disabled */import { render } from "./SuccessQuizResult.vue?vue&type=template&id=33077541&scoped=true&ts=true"
import script from "./SuccessQuizResult.vue?vue&type=script&lang=ts"
export * from "./SuccessQuizResult.vue?vue&type=script&lang=ts"

import "./SuccessQuizResult.vue?vue&type=style&index=0&id=33077541&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33077541"]])

export default __exports__